<template>
	<div id="Main">
		<div class="imgbox">
			<van-image width="60%" fit="contain" :src="require('../../assets/images/service/cardadd.png')" />
			<div class="title">
				<p class="p1">添加成功</p>
				<p class="p2">红利只能转入股东本人名下银行卡</p>
			</div>
			<van-button type="info" class="submit" @click="submit">确定</van-button>
		</div>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				user:'',
				name:''
			}
		},
		methods: {
			submit() {
				this.$router.push({
					path: '/bankCardList',
					query:{
						user:this.user,
						name:this.name,
					}
				})
			},
		},
		mounted() {
			this.user = this.$route.query.user
			this.name = this.$route.query.name
			if(this.$route.query.id){
				this.id = this.$route.query.id
			}	
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		background-color: #f2f9ff;
		min-height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		.submit {
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			margin: 2rem 0;
			margin-top: 10rem;
			border-radius: 5px;
		}


		.title {
			margin: 1.5rem 0;
			.p1 {
				font-weight: bold;
				color: #161616;
				font-size: 1.8rem;
				line-height: 2.5rem;
			}

			.p2 {
				color: #999999;
				font-size: 1.4rem;
				line-height: 2rem;
			}
		}

		.bor0 {
			border-bottom: 0;
		}

	}
</style>
